import { StockCondition, StockStatus } from "../types/stock.types";

export const getStockConditionLabel = (condition: StockCondition): string => {
  const labels: Record<StockCondition, string> = {
    [StockCondition.NEW]: "Novo",
    [StockCondition.USED]: "Usado",
    [StockCondition.WORN_OUT]: "Desgastado",
  };
  return labels[condition];
};

export const getStockStatusLabel = (status: StockStatus): string => {
  const labels: Record<StockStatus, string> = {
    [StockStatus.AVAILABLE]: "Disponível",
    [StockStatus.RENTED]: "Alugado",
    [StockStatus.ON_STREET]: "Na Rua",
    [StockStatus.MAINTENANCE]: "Manutenção",
  };
  return labels[status];
};

export const getStockStatusClass = (status: StockStatus): string => {
  const classes: Record<StockStatus, string> = {
    [StockStatus.AVAILABLE]:
      "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    [StockStatus.RENTED]: "bg-blue-500/15 text-blue-300 border-blue-500/30",
    [StockStatus.ON_STREET]:
      "bg-amber-500/15 text-amber-300 border-amber-500/30",
    [StockStatus.MAINTENANCE]:
      "bg-rose-500/15 text-rose-300 border-rose-500/30",
  };
  return classes[status];
};
